<template>
    <div  style="justify-content: flex-start !important;">
        <div v-dragula="temp_videoArray" :service="componentId" :drake="componentId">
            <div :style="`float: left;margin:0px ${interval??0}px ${interval??0}px 0px`" v-for="(video, index) in temp_videoArray" :key="video.videoId">
                <b-button v-b-toggle="'videoupload_' + componentId + video.videoId"
                    :ref="'videoupload_' + componentId + video.videoId" variant="light" class="btn btn-light"
                    :disabled="disable"  :style="`padding: 0px;writing-mode: vertical-lr;width:${ShowWidth??80}px;height:${ShowHeight??100}px`" >
                    <img class="img-fluid top-radius-blog" :src="video.imageSrc" alt="">
                </b-button>
                <b-sidebar sidebar-class="imgSidebar" :ref="'videoupload_sidebar_' + componentId + video.videoId"
                    :id="'videoupload_' + componentId + video.videoId" title="" right bg-variant="white" backdrop
                    @hidden="sidebarHidden(video.videoId)" :shadow="true" @change="toggleBodyScrollbar">
                    <videoUploadDetail :videoId="video.videoId" :videoSrc="video.videoSrc" :UpdateVideo="UpdateVideo"
                        :videoName="video.videoName" :imageSrc="video.imageSrc" :DeleteVideo="DeleteVideo"
                        :FileName="video.FileName"
                        :nextBtn="index + 1 < temp_videoArray.length || !reachLimit ? btnNext_Click : null"
                        :prevBtn="index - 1 >= 0 ? btnPrev_Click : null" :ref="'newVideoUploadDetail_' + componentId + video.videoId"
                        :verticalCover="myVerticalCover">
                    </videoUploadDetail>
                    <!-- <button></button> -->
                </b-sidebar>
            </div>
        </div>

        <b-button v-b-toggle="'videoupload_' + componentId + '0'" variant="light" :class="ReturnRequied ? 'ButtonStyle' : '' "
            :style="`width:${ShowWidth??80}px;height:${ShowHeight??100}px`" :ref="'videoupload_' + componentId + '0'" v-if="!reachLimit"
            :disabled="disable">
            <i v-if="!IsHidenAddIcon" class="icofont icofont-ui-add font-dark"></i>
            <slot name="AddText"></slot>
        </b-button>
        <b-sidebar sidebar-class="imgSidebar" :ref="'videoupload_sidebar_' + componentId + '0'" @hidden="sidebarHidden(0)"
            :id="'videoupload_' + componentId + '0'" title="" right bg-variant="white" backdrop :shadow="true"
            @change="toggleBodyScrollbar">
            <videoUploadDetail :videoId="0" :UpdateVideo="UpdateVideo" videoName="" :DeleteVideo="DeleteVideo"
            :ref="'newVideoUploadDetail_' + componentId + 0" :prevBtn="temp_videoArray.length > 0 ? btnPrev_Click : null" :verticalCover="myVerticalCover">
            </videoUploadDetail>
        </b-sidebar>
        <div v-if="ReturnRequied" style="color: red;padding-left: 6px;padding-top: 2px;">{{$t("lbl_EMPBE_Please_Upload_Video")}}</div>
    </div>
</template>
<script>
import videoUploadDetail from './videoUploadDetail.vue';
import { fileUploadService } from '../../../_services';
export default {
    props: ["componentId", "limit", "videoWidth", "videoHeight", "disable", "videoArray",
    "IsRequired", "verticalCover","ShowHeight","ShowWidth",'IsHidenAddIcon','interval'],
    components: {
        videoUploadDetail
    },
    data() {
        return {
            temp_videoArray: this.videoArray != null ? this.videoArray : [], //videoId, videoName, videoSrc, imageSrc, modified, videoCdnLnk, imgCdnLnk, FileName
            mylimit: this.limit ? this.limit : 1,
            reachLimit: false,
            IsRequiredStyle:false,
            IsCreated:true,
            myVerticalCover: this.verticalCover
        };
    },
    watch: {
        videoArray() {
            this.temp_videoArray = this.videoArray != null ? this.videoArray : [];

            this.reachLimit = this.mylimit <= this.temp_videoArray.length;
        },
        reachLimit()
        {
        if(this.IsRequired && !this.IsCreated)
        {
            this.IsRequiredStyle=!this.reachLimit;
        }
        }
    },
    computed: {
        ReturnRequied(){
            return this.IsRequiredStyle && this.IsRequired && (this.temp_videoArray.length<1)
        }
    },
    mounted() {
        this.reachLimit = this.mylimit <= this.temp_videoArray.length;    
        this.IsCreated=false;
    },
    methods: {
        toggleBodyScrollbar(visible) {
            const body = document.getElementsByTagName('body')[0];

            if (visible)
                body.classList.add("overflow-hidden");
            else
                body.classList.remove("overflow-hidden");
        },
        UpdateVideo(videoId, videoSrc, imageSrc, videoName, FileName) {
            console.log('UpdateVideo')
             
            if (videoSrc != '' && videoSrc != undefined) {
                if (videoId < 1) {
                    var newvideoId = this.temp_videoArray.length + 1;
                    this.temp_videoArray.push({ videoId: newvideoId, videoSrc: videoSrc, imageSrc: imageSrc, modified: true, videoName: videoName, videoCdnLnk: "", imgCdnLnk: "", FileName: "" });
                }
                else {
                    this.temp_videoArray.find(video => {
                        if (video.videoId === videoId) {
                            //Check if modified - Fix: Compare with parameter imageSrc, not video.imageSrc
                            const videoSrcChanged = video.videoSrc != videoSrc;
                            const imageSrcChanged = video.imageSrc != imageSrc;
                            const videoNameChanged = video.videoName != videoName;
                            const fileNameChanged = video.FileName != FileName;
                            
                            if (videoSrcChanged || imageSrcChanged || videoNameChanged || fileNameChanged) {
                                video.videoSrc = videoSrc;
                                video.imageSrc = imageSrc;
                                video.modified = true;
                                video.videoName = videoName;
                                video.FileName = FileName || "";
                                
                                // Only clear CDN links if we're uploading new base64 content
                                // If the new source is already a CDN link, preserve it
                                if (videoSrcChanged) {
                                    if (videoSrc.includes('https://')) {
                                        // New source is a CDN link, use it as videoCdnLnk
                                        video.videoCdnLnk = videoSrc;
                                    } else {
                                        // New source is base64, clear CDN link (will be set after upload)
                                        video.videoCdnLnk = "";
                                    }
                                }
                                
                                if (imageSrcChanged) {
                                    if (imageSrc.includes('https://')) {
                                        // New source is a CDN link, use it as imgCdnLnk
                                        video.imgCdnLnk = imageSrc;
                                    } else {
                                        // New source is base64, clear CDN link (will be set after upload)
                                        video.imgCdnLnk = "";
                                    }
                                }
                                
                                // If only name changed, preserve existing CDN links
                                if (!videoSrcChanged && !imageSrcChanged) {
                                    // Keep existing videoCdnLnk and imgCdnLnk
                                }
                            }
                            // If nothing changed, modified stays false and CDN links are preserved
                        }
                    })
                }
            }
            if (videoId == 0) {
                this.$refs["videoupload_" + this.componentId + videoId].click()
            } else {
                this.$refs["videoupload_" + this.componentId + videoId][0].click()
            }
            this.reachLimit = this.mylimit <= this.temp_videoArray.length;
        },
        DeleteVideo(videoId) {
            let i = this.temp_videoArray.map(video => video.videoId).indexOf(videoId) // find index of your object
            this.$refs['videoupload_sidebar_' + this.componentId + videoId][0].hide();
            setTimeout(() => {
                this.temp_videoArray.splice(i, 1) // remove it from array
                this.reachLimit = this.mylimit <= this.temp_videoArray.length;
            }, 300)
        },
        AppendUploadQuery() {
            fileUploadService.AppendQuery(this.componentId, "Video", this.temp_videoArray);
        },
        btnNext_Click(videoId) {
            let i = this.temp_videoArray.map(video => image.videoId).indexOf(videoId) // find index of your object
            this.$refs['videoupload_sidebar_' + this.componentId + videoId][0].hide();
            if (i + 1 < this.temp_videoArray.length) {
                var next = this.temp_videoArray[i + 1];
                this.$root.$emit('bv::toggle::collapse', this.$refs['videoupload_sidebar_' + this.componentId + next.videoId][0].id)
            } else if (!this.reachLimit) {
                this.$root.$emit('bv::toggle::collapse', this.$refs['videoupload_sidebar_' + this.componentId + '0'].id)
            }
        },
        btnPrev_Click(videoId) {
            if (videoId == 0) {
                this.$refs['videoupload_sidebar_' + this.componentId + '0'].hide();
                var next = this.temp_videoArray[this.temp_videoArray.length - 1];
                this.$root.$emit('bv::toggle::collapse', this.$refs['videoupload_sidebar_' + this.componentId + next.videoId][0].id)
            } else {
                let i = this.temp_videoArray.map(video => image.videoId).indexOf(videoId) // find index of your object
                this.$refs['videoupload_sidebar_' + this.componentId + videoId][0].hide();
                if (i - 1 >= 0) {
                    var next = this.temp_videoArray[i - 1];
                    this.$root.$emit('bv::toggle::collapse', this.$refs['videoupload_sidebar_' + this.componentId + next.videoId][0].id)
                }
            }

        },
        sidebarHidden(videoId) {
            if (videoId > 0) {
                // this.$refs["newVideoUploadDetail_" + this.componentId + videoId][0].confirm();
                // this.$refs["videoupload_sidebar_" + this.componentId + videoId][0].hide();
            } else {
                // this.$refs["newVideoUploadDetail_" + this.componentId + videoId].confirm();
                this.$refs["newVideoUploadDetail_" + this.componentId + videoId].remove();
            }
        }
    }
}
</script>
<style>
.icofont {
    /* color: black; */
}
</style>
<style scoped>
.ButtonStyle
{
  border: 1px solid red !important;
}
</style>